import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const AbscondDriverFilterForm = ({ applyFilter }) => {
  const filterInputs = {
    status: "PENDING"
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(
        localStorage.getItem("applyFilter") &&
          localStorage.getItem("applyFilter")
      );
      const status = await JSON.parse(
        localStorage.getItem("statusFilter") &&
          localStorage.getItem("statusFilter")
      );
      if (roles && status) {
        setFilterFieldsData(roles);
        setListStatus(status);
      }
    })();
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData &&
          localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus &&
          localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
      <DropDownInput
        data={[
          { id: "PENDING", name: "PENDING" },
          { id: "PROCESSED", name: "PROCESSED" },
          { id: "REJECTED", name: "REJECTED" },
        ]}
        label={localization.status}
        value={
          filterFieldsData?.status !== null ? filterFieldsData?.status : ""
        }
        getIdValue={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            status: val.id,
          });
        }}
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
            applyFilter(filterInputs);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default AbscondDriverFilterForm;
